import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";

import Button from "../../components/Button";
import { StyledSwitch } from "../../components/Base";
import { getProgressPassCondition, addPassConditionTrainingUser } from "../../api/training.deprecated";

const ProgressTraining = ({ match, history }) => {
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(1);
  const [passCondition, setPassCondition] = useState([]);

  useEffect(() => {
    (async () => {
      const trainingId = match.params.trainingId;
      const userId = parseInt(match.params.userId);

      const passConditionList = await getProgressPassCondition(trainingId, userId);
      setPassCondition(passConditionList);
    })();
  }, [refresh]);
  return (
    <>
      <Typography variant="h4">{t("training.checking_progress")}</Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label={t("training.progress_table")}>
          <TableHead>
            <TableRow>
              <TableCell>{t("id")}</TableCell>
              <TableCell>{t("training.module")}</TableCell>
              <TableCell>{t("training.pass_conditions")}</TableCell>
              <TableCell>{t("training.type")}</TableCell>
              <TableCell>{t("training.value")}</TableCell>
              <TableCell>{t("status")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {passCondition.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.module}</TableCell>
                <TableCell>{row.passConditionName}</TableCell>
                <TableCell>{row.passConditionType}</TableCell>
                <TableCell>{row.passConditionValue}</TableCell>
                <TableCell>
                  <StyledSwitch
                    title={t("training.passed")}
                    checked={row.passConditionTrainingUserId != null}
                    onChange={async () => {
                      await addPassConditionTrainingUser(row.passConditionTrainingUserId, row.userId, row.id);

                      setRefresh(refresh + 1);
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button title={t("navigate_back")} type="button" onClick={() => history.push("/training-users/user")}>
        {t("training.return_to_training_users")}
      </Button>
    </>
  );
};

export default ProgressTraining;
